<div id="get-login" fxLayout="column">

    <div id="get-login-form-wrapper" fxLayout="column" fxLayoutAlign="center center">

        <div id="get-login-form" [@animate]="{value:'*',params:{duration:'300ms',y:'100px'}}">

            <div class="logo">
                <img src="../../../../assets/images/logo/giant2.png">
            </div>

            <div class="title">LOGIN INFORMATION</div>

            <form name="getLoginForm" #getLoginForm="ngForm" (ngSubmit)="getLoginForm.form.valid && onGetLogin()" novalidate [mustMatch]="['password', 'confirm_password']">

                <mat-form-field appearance="outline">
                    <mat-label>User ID</mat-label>
                    <input matInput type="text" name="userId" required #userId="ngModel" [(ngModel)]=getLoginModel.UserID [ngClass]="{ 'is-invalid': getLoginForm.submitted && userId.invalid }">
                    <mat-icon matSuffix class="secondary-text">perm_identity
                    </mat-icon>
                    <mat-error *ngIf="userId.errors?.required && userId.touched">User Id is required</mat-error>
                </mat-form-field>


                <mat-form-field appearance="outline">
                    <mat-label>Username</mat-label>
                    <input matInput type="text" name="username" required #username="ngModel" [(ngModel)]=getLoginModel.Username [ngClass]="{ 'is-invalid': getLoginForm.submitted && username.invalid }">
                    <mat-icon matSuffix class="secondary-text">perm_identity
                    </mat-icon>
                    <mat-error *ngIf="username.errors?.required && username.touched">User Name is required</mat-error>
                </mat-form-field>


                <mat-form-field appearance="outline">
                    <mat-label>Unique Ref</mat-label>
                    <input matInput type="text" name="unique_ref" required #unique_ref="ngModel" [(ngModel)]=getLoginModel.Unique_Ref [ngClass]="{ 'is-invalid': getLoginForm.submitted && unique_ref.invalid }">
                    <mat-icon matSuffix class="secondary-text">credit_card
                    </mat-icon>
                    <mat-error *ngIf="unique_ref.errors?.required && unique_ref.touched">Unique Ref is required</mat-error>
                </mat-form-field>


                <mat-form-field appearance="outline">
                    <mat-label>Password</mat-label>
                    <input matInput type="password" name="password" required #password="ngModel" [(ngModel)]=getLoginModel.Password [ngClass]="{ 'is-invalid': getLoginForm.submitted && password.invalid }">
                    <mat-icon matSuffix class="secondary-text">vpn_key
                    </mat-icon>
                    <mat-error *ngIf="password.errors?.required && password.touched">Password Name is required</mat-error>
                </mat-form-field>



                <mat-form-field appearance="outline">
                    <mat-label>Confirm Password</mat-label>
                    <input matInput type="password" name="confirm_password" required #confirm_password="ngModel" [(ngModel)]=getLoginModel.Confirm_Password [ngClass]="{ 'is-invalid': getLoginForm.submitted && confirm_password.invalid }">
                    <mat-icon matSuffix class="secondary-text">vpn_key
                    </mat-icon>
                    <mat-error *ngIf="confirm_password.errors?.required && confirm_password.touched">Confirm Password is required</mat-error>
                    <mat-error *ngIf="confirm_password.errors?.mustMatch && confirm_password.touched">Passwords must match</mat-error>
                </mat-form-field>

                <button mat-raised-button color="accent"  class="submit-button" aria-label="GET LOG IN"
                [disabled]="!getLoginForm.form.valid">
                    CONTINUE TO LOGIN
                </button>

            </form>

        </div>

    </div>

</div>